import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { FilterInputProps } from "./FilterInput.types";
import { MelaInput } from "../../../mela/MelaInput";
import { MelaButton } from "../../../mela/MelaButton";

/**
 * Text filter input component.
 */
export const TextFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
  placeholder = "Filtra...",
}) => {
  const ClearButton = value ? (
    <MelaButton
      iconOnly
      size="sm"
      variant="ghost"
      tone="neutral"
      onClick={() => onChange(null)}
      aria-label="Clear filter"
      startIcon={<ClearIcon fontSize="small" />}
      style={{
        minWidth: 24,
        width: 24,
        height: 24,
        padding: 0,
        borderRadius: "50%",
        boxShadow: "none",
      }}
    />
  ) : null;

  const size =
    density === "compact" ? "xxs" : density === "standard" ? "xs" : "sm";

  return (
    <MelaInput
      size={size}
      placeholder={placeholder}
      value={(value as string) || ""}
      onChange={(e) => onChange(e.target.value || null)}
      fullWidth
      endIcon={ClearButton}
    />
  );
};
